module.exports = __webpack_public_path__ + "static/media/back_man.2a7e65fc.svg";